import moment from "moment";
import React from "react";
import ToolTip from "../../../common/ToolTip/ToolTip";

const SingleShiftClaimInfo = (props) => {
  const { claimedCandidateInfo, jobTitle } = props;
  const shiftHoursCalc = (time) => {
    let shiftHours = "";
    const hours = Math.floor(parseInt(time) / 60);
    const minutes = parseInt(time) % 60;
    if (hours) {
      shiftHours += `${hours} ${parseInt(hours) === 1 ? "hr " : "hrs "}`;
    }
    if (minutes) {
      shiftHours += `${minutes} mins`;
    }
    return shiftHours;
  };

  const VariablePayRateTable = (
    <table className="table table-responsive">
    <thead>
      <tr>
        <th className="text-capitalize">Start Time</th>
        <th className="text-capitalize">End Time</th>
        <th className="text-capitalize">Mark Up</th>
      </tr>
    </thead>
    <tbody>
      {
        claimedCandidateInfo?.payRates?.map((item, index) => {
          return (
            <tr className="border-bottom mt-2 bg-white">
              <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
              <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
              <td>{item?.markup ? `$ ${item?.markup}`:''}</td>
            </tr>
          )
        })
      }
    </tbody>
  </table>
  )

  return (
    <>
    <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="card-header">
              <b>
                <h5 class="mb-0">Single Shift Info</h5>
              </b>
            </div>
          </div>
        </div>
        <div className="card-body">
          {/* first-row => Shift Title */}
          <div className="row">
            <div className="d-flex">
              <div className="col-6">
                <label className="form-label">Shift Title:</label>
                <label>{jobTitle}</label>
              </div>
            </div>
          </div>
          {/* Second Row => Claimed details*/}
          <div className="row ">
            <div className="d-flex ">
              {/* Claimed By */}
              <div className="col-2">
                <label className="form-label">Claimed By:</label>
                <label>{claimedCandidateInfo?.candidateName}</label>
              </div>
              {/* Claimed Date */}
              <div className="col-2">
                <label className="form-label"> Claimed Date:</label>
                <label>
                  {claimedCandidateInfo?.claimedDateToDisplay
                    ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                        "MM/DD/YYYY"
                      )
                    : ""}
                </label>
              </div>
              {/* Claimed Time */}
              <div className="col-2">
                <label className="form-label">Claimed Time:</label>
                <label>
                  {claimedCandidateInfo?.claimedDateToDisplay
                    ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                        "hh:mm A"
                      )
                    : ""}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Shift Hours :</label>
                <label htmlFor="Location Name">
                  {/* {props?.jobDetails?.shiftHours} */}
                  {props?.shiftHours ? shiftHoursCalc(props?.shiftHours) : ""}
                </label>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
            </div>
          </div>
          {/* Third Row => Shift Date details*/}
          <div className="row ">
            <div className=" d-flex  ">
              <div className="col-2">
                <label className="form-label">Shift Date</label>
                <label htmlFor="Location Name">{props?.jobDateToDisplay}</label>
              </div>
              <div className="col-2">
                <label className="form-label">Shift Start Time</label>
                <label htmlFor="Location Name">
                  {claimedCandidateInfo?.isClaimed &&
                  claimedCandidateInfo?.jobDate
                    ? moment(claimedCandidateInfo?.jobDate).format("hh:mm A")
                    : props?.shiftStartTime}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Shift End Time</label>
                <label htmlFor="Address">
                  {claimedCandidateInfo?.isClaimed &&
                  claimedCandidateInfo?.jobEndDate
                    ? moment(claimedCandidateInfo?.jobEndDate).format("hh:mm A")
                    : props?.shiftEndTime}
                </label>
              </div>
              <div className="col-2">
                <div className="col-2"></div>
                <div className="col-2"></div>
                <div className="col-2"></div>
              </div>
            </div>
          </div>
          {/* FourthRow => checkIn Details */}
          <div className="row ">
            <div className="d-flex  ">
              <div className="col-2">
                <label className="form-label">Check In Date:</label>
                <label
                // style={{
                //   background: `${
                //     claimedCandidateInfo?.checkInStatus === 2
                //       ? "#ffd300"
                //       : "#fff"
                //   }`,
                // }}
                >
                  {claimedCandidateInfo?.checkedInDateToDisplay
                    ? moment(
                        claimedCandidateInfo?.checkedInDateToDisplay
                      ).format("MM/DD/YYYY")
                    : ""}
                </label>
              </div>
              <div className="col-2">
                <ToolTip
                  position={"top"}
                  value={claimedCandidateInfo?.checkedInDateToolTipToDisplay}
                >
                <div>
                <label style={{ cursor: "pointer" }} className="form-label">
                    Checked In Time:
                  </label>
                  <label
                  style={{
                    background: `${
                      claimedCandidateInfo?.lateCheckedInTime && "#ffd300"
                    }`,
                  }}
                >
                  {claimedCandidateInfo?.checkedInDateToDisplay
                    ? moment(
                        claimedCandidateInfo?.checkedInDateToDisplay
                      ).format("hh:mm A")
                    : ""}{" "}
                  {claimedCandidateInfo?.lateCheckedInTime &&
                    `(${claimedCandidateInfo?.lateCheckedInTime})`}
                </label>
                </div>
                </ToolTip>
            
              </div>
              <div className="col-2">
                <label className="form-label">Check Out Date:</label>
                <label>
                  {claimedCandidateInfo?.checkedOutDateToDisplay
                    ? moment(
                        claimedCandidateInfo?.checkedOutDateToDisplay
                      ).format("MM/DD/YYYY")
                    : ""}
                </label>
              </div>
              <div className="col-2">
                <ToolTip
                  position={"top"}
                  value={claimedCandidateInfo?.checkedOutDateToolTipToDisplay}
                >
                 <div>
                 <label style={{ cursor: "pointer" }} className="form-label">
                    Check Out Time:
                  </label>
                  <label
                  style={{
                    background: `${
                      claimedCandidateInfo?.lateCheckedOutTime && "#ffd300"
                    }`,
                  }}
                >
                  {claimedCandidateInfo?.checkedOutDateToDisplay
                    ? moment(
                        claimedCandidateInfo?.checkedOutDateToDisplay
                      ).format("hh:mm A")
                    : ""}{" "}
                  {claimedCandidateInfo?.lateCheckedOutTime &&
                    `(${claimedCandidateInfo?.lateCheckedOutTime})`}
                </label>
                 </div>
                </ToolTip>
                
              </div>
              <div className="col-2">
                <label className="form-label">Paid Date:</label>
                <label>
                  {claimedCandidateInfo?.paidDateToDisplay
                    ? moment(claimedCandidateInfo?.paidDateToDisplay).format(
                        "MM/DD/YYYY"
                      )
                    : ""}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Paid Time:</label>
                <label>
                  {claimedCandidateInfo?.paidDateToDisplay
                    ? moment(claimedCandidateInfo?.paidDateToDisplay).format(
                        "hh:mm A"
                      )
                    : ""}
                </label>
              </div>
            </div>
          </div>
          {/* FifthRow => Candidate BillingRate Details */}
          <div className="d-flex ">
            <div className="col-2">
              <label className="form-label">
                Candidate Work Duration Hours:
              </label>
              <label>{claimedCandidateInfo?.totalworkedHourToDisplay}</label>
            </div>
            <div className="col-2">
              <label className="form-label">Candidate Hourly Base Rate:</label>
              <label>
                {claimedCandidateInfo?.candidateHourlyBaseRateToDisplay}
              </label>
            </div>
            <div className="col-2">
              <label className="form-label">Variable Shift Mark Up:</label>
              <label>
                <span style={{marginRight:"0.5rem", display:"inline-block"}}>{claimedCandidateInfo?.variableShiftMarkupToDisplay}</span>
                <span  >{(claimedCandidateInfo?.variableShiftMarkupToDisplay === "Variable") ? (
                      <ToolTip position={"top"} value={VariablePayRateTable}>
                      <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                      </ToolTip>):""}</span>   
              </label>
            </div>
            <div className="col-2">
              <label className="form-label">Mileage Mark Up:</label>
              <label>{claimedCandidateInfo?.mileageMarkupToDisplay}</label>
            </div>
            <div className="col-2">
              <label className="form-label">Candidate Hourly Pay Rate:</label>
              <label>
              {(claimedCandidateInfo?.candidateHourlyPayrateToDisplay && claimedCandidateInfo?.candidateHourlyPayrateToDisplay !== "Variable" ) ? `$ ${claimedCandidateInfo?.candidateHourlyPayrateToDisplay}`:claimedCandidateInfo?.candidateHourlyPayrateToDisplay}
              </label>
            </div>
            <div className="col-2">
              <label className="form-label">Candidate Payment Amount:</label>
              <label>
                {claimedCandidateInfo?.candidateTotalAmountToDisplay}
              </label>
            </div>
          </div>
          {/* sixthRow => Incentive Details */}
          <div className="row">
            <div className="d-flex">
              <div className="col-2">
                <label className="form-label">Incentive:</label>
                <label>{props?.incentiveToDisplay}</label>
              </div>
              <div className="col-2">
                <label className="form-label">Incentive Mark Up:</label>
                <label>{props?.incentiveMarkup ? props?.incentiveMarkup:''}</label>
              </div>
              <div className="col-2">
                <label className="form-label">Incentive Billing Amount:</label>
                <label>
                  {props?.employerIncentiveToDisplay}
                </label>
              </div>
            </div>
          </div>
          {/* seventhRow => Candidate BillingRate Details  */}
          <div className="row">
            <div className="d-flex">
              <div className="col-2">
                <label className="form-label">Employer Billing Mark Up :</label>
                <label>
                  {claimedCandidateInfo?.employerBillingMarkupToDisplay}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">
                  Employer Hourly Base Rate :
                </label>
                <label>
                {(claimedCandidateInfo?.employerHourlyBaseRateToDisplay && claimedCandidateInfo?.employerHourlyBaseRateToDisplay !== "Variable" ) ? `$ ${claimedCandidateInfo?.employerHourlyBaseRateToDisplay}`:claimedCandidateInfo?.employerHourlyBaseRateToDisplay}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">
                  Employer Hourly Billing Rate:
                </label>
                <label>
                  {(claimedCandidateInfo?.employerHourlyBillingRateToDisplay && claimedCandidateInfo?.employerHourlyBillingRateToDisplay !== "Variable") ? `$ ${claimedCandidateInfo?.employerHourlyBillingRateToDisplay}`:claimedCandidateInfo?.employerHourlyBillingRateToDisplay }
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Employer Billing Amount :</label>
                <label>
                  {claimedCandidateInfo?.employerBillAmountToDisplay}
                </label>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};

export default SingleShiftClaimInfo;
